import {makeStyles} from "@material-ui/core";

export default makeStyles(theme => {
    return ({
        centreAbsolute: {
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            "& > svg": {
                width: "80vw",
                height: "80vw",
                fill: theme.palette.success.main
            }
        },
        main:{
            position: "absolute",
            top: 50,
            left: 0,
            bottom: 0,
            right: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: theme.spacing(4),
            "& h4": {
                marginBottom:theme.spacing(4)
            }
        }
    })
})
